module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag25_1209AT.4e4cc41f.jpg";